<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<section class="main-content form-section">
			<div class="row contact-form-row">
				<div class="form-inner-wrapper row">
					<div class="columns column7 contact-form-col">
						<contact-form name="contact" :form="form" />
					</div>
					<div class="columns column1">
						<div class="vertical-divider" />
					</div>
					<div class="columns column4">
						<h4>{{ $t('locationAndContact') }}</h4>
						<p class="address">
							<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span
							><br />
							<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span
							><br />
							<span>{{ defaults[locale].website.country }}</span
							><br />
							<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
								<span>{{ defaults[locale].website.phone }}</span> </a
							><br />
							<a :href="`mailto:${defaults[locale].website.email}`">
								<span>{{ defaults[locale].website.email }}</span>
							</a>
						</p>
					</div>
				</div>
			</div>
		</section>
		<frequently-asked-questions v-if="page.faqs && page.faqs.length" :items="page.faqs" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});

useHead({
	bodyAttrs: {
		class: 'contact',
	},
});
</script>

<style lang="scss" scoped>
:deep(h1) {
	color: var(--header-color);
}

#maps {
	min-height: 600px;
}

.form-section {
	padding: 0;
}

.form-inner-wrapper {
	background: var(--primary-background-color);
	width: 96%;
	padding: 80px 60px;

	a {
		color: var(--body-color);
		text-decoration: none;
	}
}

h4 {
	color: var(--header-color);
	margin: 0 0 10px;
}

.vertical-divider {
	margin: 0 auto;
	height: 100%;
}

@media (max-width: 1080px) {
	.form-inner-wrapper {
		flex-flow: column-reverse;
		padding: 50px 25px;
	}

	.column1 {
		display: none;
	}

	.column4 {
		width: 100%;
		margin: 0 0 20px;
	}
}
</style>
